// Additional context:
// https://tagmanaging.page/2023/10/23/google-ads-enhanced-conversions-is-insecure/
// https://developers.google.com/google-ads/api/docs/conversions/enhanced-conversions/web#prepare-data

import * as Sentry from '@sentry/react'

import { formatE164PhoneNumber, stringToSHA256Hash } from '@scouts/helpers'

export const getHashedTrackingData = async (params: { phoneNumber?: string; postcode?: string; email?: string }) => {
    try {
        return {
            hashedEmail: await stringToSHA256Hash(normalizeEmail(params.email ?? '')),
            hashedPhoneNumber: params.phoneNumber
                ? await stringToSHA256Hash(formatE164PhoneNumber(params.phoneNumber ?? '', { countryPrefix: '+34' }))
                : undefined,
        }
    } catch (error) {
        Sentry.captureException(error)
        return {}
    }
}

const normalizeEmail = (unformattedEmail: string): string => {
    const email = unformattedEmail.trim().toLowerCase()

    // Check if the email is a Gmail or Googlemail address
    const emailRegex = /^([a-zA-Z0-9._%+-]+)@(gmail|googlemail)\.com$/i

    if (emailRegex.test(email)) {
        // Split the email into the local part and domain part
        const domain = email.split('@')[1]
        let localPart = email.split('@')[0]

        // Remove everything after the + symbol in the local part
        localPart = localPart.split('+')[0]

        // Remove all dots from the local part
        localPart = localPart.replace(/\./g, '')

        // Rebuild the normalized email
        return `${localPart}@${domain}`
    }

    // If the email is not Gmail or Googlemail, return it as is
    return email
}
